import React from "react";
import Header from "../components/header";
import {GatsbyImage} from 'gatsby-plugin-image'
import info from "../info.json";
import ProductCard from "../components/product-card";
import Form from "../components/form";
import { graphql } from "gatsby";

import InfoPopUp from "../components/info-popup"
import Slider from "../components/slider";
import Seo from "../components/seo"


export default function CategoryTemplate({ data }){
    
    const [visible, setVisible] = React.useState(false)
    const [visibleInfo, setVisibleInfo] = React.useState(false)

    const productList = [...data.wpCategory.flowers.nodes]
    const collectionName = data.wpCategory.name   

    var boolInfo = data.wpCategory.moreAbout.moretext != undefined ? true : false 
        

    return(
        <div className="relative overflow-hidden h-[100dvh]">
            <Header/>
            {/* <Form visible={visible} setVisible={setVisible} type="Category" currentPage={collectionName}/> */}
            {boolInfo && <InfoPopUp visibleInfo={visibleInfo} setVisibleInfo={setVisibleInfo} type="Homepage" currentPage={"Red Roses Collection"} moreAbout={data.wpCategory.moreAbout}/>}

            <Slider productsList={productList} boolInfo={boolInfo} visibleInfo={visibleInfo} setVisibleInfo={setVisibleInfo}  setVisible={setVisible} collection={collectionName} sliderLength={productList.length} catalog={data.wpPage.homepage.catalog}/>
        </div>
    )
}


export function Head({data}){

    const {wpCategory:{seo}} = data
  
    return(
        <Seo
        title={seo.title}
        description={seo.metaDesc}
        url={data.site.siteMetadata.siteUrl + '/category/' + data.wpCategory.slug}

      >    
      </Seo>
    )
  
}


export const query = graphql`
    query CategoryProducts($slug: String) {
        site{
            siteMetadata{
                siteUrl
            }
        }
        wpCategory(slug: {eq: $slug}) {
            name
            slug
            seo{
                title
                metaDesc
                canonical
            }
            moreAbout {
                moretext
                moretitle
            }
            flowers {
                nodes {
                    slug
                    title
                    featuredImage {
                        node {
                            gatsbyImage(width: 700, height: 1100 placeholder: NONE)
                        }
                    }
                    categories {
                        nodes {
                            name
                            slug
                        }
                    }
                    flowerExtraFields {
                        isNew
                        color
                    }
                }
            }
        }
        wpPage(title: {eq: "Home"}) {
            homepage {
                catalog
            }
           
        }
    }
`